export enum PackageName {
  ROOT_DOCUMENT_NAME = 'name',
  ROOT_DOCUMENT_NUMBER = 'number',
}
